import { Box, Typography } from '@mui/material'
import { leadershipWhy } from '../../data/leadershipContent'
import StarBullet from '../common/StarBullet'

export default function LeadershipWhySection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
        }}
      >
        {leadershipWhy.title}
      </Typography>

      <Box
        component="ul"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          width: { xs: '100%', lg: 1000 },
          maxWidth: '100%',
          m: 0,
          p: 0,
          listStyle: 'none',
        }}
      >
        {leadershipWhy.items.map((item) => (
          <Box
            component="li"
            key={item}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <StarBullet src={leadershipWhy.bulletIcon} />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 20, sm: 24, md: 30, lg: 30 },
                lineHeight: 'normal',
                fontWeight: 400,
                color: '#111',
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
